import React from "react"

function AccountPage()
{
    return <>MyAccount</>;
};

export default AccountPage;